module.exports = __webpack_public_path__ + "static/media/hero frame.53d7b9f8.svg";